// TimePick.jsx
import React from "react";

export const TimePick = React.forwardRef(({ name, className, value, onChange }, ref) => {
  return (
    <input
      ref={ref}
      type="time"
      name={name}
      className={className}
      value={value || ""}
      onChange={(e) => onChange(e.target.value)}
    />
  );
});
